<template>
  <div :class="{disabled: (responsive === 'tablet' && item.data.disabledTablet) || (responsive === 'mobile' && item.data.disabledMobile)}">
    <div v-if="isActive" :style="activeTabletMenuAcc" class="activeAcc top"></div>
    <div class="menuItem" :style="isActive && activeTabletMenu">
      {{item.data.label[ln]}}
      <button v-if="item.children && item.children.length" type="button" :class="{openChildren: true, open: state.open}" @click="openChildren">
        <span class="left" :style="barColor"></span>
        <span class="right" :style="barColor"></span>
        <span class="blind">open</span>
      </button>
    </div>
    <div v-if="isActive" :style="activeTabletMenuAccBottom" class="activeAcc bottom"></div>
    <div v-if="item.children && item.children.length && state.open" class="innerList">
      <RenderItem
        v-for="item in item.children"
        :key="item.id"
        :ln="ln" :item="item"
        :isActive="isActive"
        :activeTabletMenu="activeTabletMenu"
        :activeTabletMenuAcc="activeTabletMenuAcc" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RenderItem',
  props: [
    'ln',
    'isActive',
    'responsive',
    'item',
    'activeTabletMenu',
    'activeTabletMenuAcc'
  ],
  computed: {
    barColor () {
      const color = this.$store.getters['setting/getData'].colors.menuText
      return {
        backgroundColor: color
      }
    },
    activeTabletMenuAccBottom () {
      return {
        background: this.activeTabletMenuAcc.background && this.activeTabletMenuAcc.background.replace('top', 'bottom')
      }
    }
  },
  data () {
    return {
      state: {
        open: true
      }
    }
  },
  methods: {
    openChildren () {
      this.state.open = !this.state.open
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  display: none;
}
</style>
